import { apiUrl } from '../../config.js';

export const getHomePageData = (cityName, mGlobal, type) => ({
    type: 'GET_HP_DATA',
    axios: true,
    options: {
        url: `${apiUrl}/home-page/index?aj=1&cityName=${cityName}&mGlobal=${mGlobal}&type=${type}`,
        method: 'get'
    }
});

export const getMostPopularVehicles = (mGlobal, categoryId, isCarsStateLevelRequest, stateId, type) => ({
    type: 'GET_MOST_POPULAR_VEHICLES',
    axios: true,
    options: {
        url: `${apiUrl}/home-page/most-popular-vehicles?mGlobal=${mGlobal}&catId=${categoryId}&isCarsStateLevelRequest=${isCarsStateLevelRequest}&stateId=${stateId}&aj=1&type=${type}`,
        method: 'get'
    }
});

export const getUpcomingCars = (categoryId) => ({
    type: 'GET_UPCOMING_VEHICLES',
    axios: true,
    options: {
        url: `${apiUrl}/home-page/upcoming-vehicles?aj=1&catId=${categoryId}`,
        method: 'get'
    }
});

export const getRecentAds = (mGlobal, categoryId, isCarsStateLevelRequest, stateId) => ({
    type: 'GET_RECENT',
    axios: true,
    options: {
        url: `${apiUrl}/home-page/get-recently-posted-ads?mGlobal=${mGlobal}&catId=${categoryId}&isCarsStateLevelRequest=${isCarsStateLevelRequest}&stateId=${stateId}&aj=1`,
        method: 'get'
    }
});



// WEBPACK FOOTER //
// ../q-cars/src/redux/actions/homepage.js